import { THEME_CHOICES, type ThemeChoice } from "@scheduler/shared";

/** The three words, and no others (Jeremy, 4 Nov 2026). */
const LABEL: Record<ThemeChoice, string> = { light: "Light", dark: "Dark", system: "System" };

/**
 * Light / Dark / System, in the header immediately to the left of Sign out, as in Canopy
 * (Jeremy, 4 Nov 2026; punch list S13). The same height as Sign out; the chosen one filled.
 */
export function ThemeSwitch({ choice, onChoose }: { choice: ThemeChoice; onChoose: (next: ThemeChoice) => void }) {
  return (
    <div className="theme-switch" role="group" aria-label="Light / Dark / System">
      {THEME_CHOICES.map((option) => (
        <button
          key={option}
          type="button"
          className={option === choice ? "on" : undefined}
          aria-pressed={option === choice}
          onClick={() => {
            if (option !== choice) onChoose(option);
          }}
        >
          {LABEL[option]}
        </button>
      ))}
    </div>
  );
}
